import { render, staticRenderFns } from "./historyRecord.vue?vue&type=template&id=3e8b35cd&scoped=true&"
import script from "./historyRecord.vue?vue&type=script&lang=js&"
export * from "./historyRecord.vue?vue&type=script&lang=js&"
import style0 from "./historyRecord.vue?vue&type=style&index=0&id=3e8b35cd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8b35cd",
  null
  
)

export default component.exports